import * as React from 'react';
import { cn } from '@/lib/utils';

interface BackgroundImageContainerProps {
	imageUrl: string;
	overlayOpacity: number;
	className?: string;
	children: React.ReactNode;
}

const BackgroundImageContainer: React.FC<BackgroundImageContainerProps> = ({
	imageUrl,
	overlayOpacity,
	className,
	children,
}) => {
	const backgroundStyle = {
		backgroundImage: `url(${imageUrl})`,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
	};

	const overlayStyle = {
		backgroundColor: `rgba(0, 0, 0, ${overlayOpacity})`,
	};

	return (
		<div className={cn('relative', className)} style={backgroundStyle}>
			<div className='absolute inset-0' style={overlayStyle}></div>
			<div className='relative z-10'>{children}</div>
		</div>
	);
};

export default BackgroundImageContainer;
